import React, { useState, useEffect } from "react";
import "../fonts.css";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";


const PetFoundLost = () => {
    const [hoveredId, setHoveredId] = useState(null);
    const navigate = useNavigate();
    const [windowWidth, setWindowWidth] = useState(
        typeof window !== "undefined" ? window.innerWidth : 0
    );
    const { t } = useTranslation();

    // 添加窗口大小监听
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // 检查是否为移动设备
    const isMobile = windowWidth <= 767;

    // 基础样式
    const styles = {
        section: {
            width: "100%",
            padding: "60px 20px",
            textAlign: "left",
            backgroundColor: "#FFF2D3",
        },
        heading: {
            fontFamily: "Helvetica",
            fontSize: isMobile ? "26px" : "44px",
            fontWeight: "bold",
            marginBottom: "30px",
            color: "#000",
            maxWidth: "1515px",
            margin: "0 auto",
        },
        button: {
            fontFamily: "Helvetica",
            backgroundColor: "#FFB60C",
            color: "#000",
            border: "none",
            padding: "10px 20px",
            borderRadius: "3px",
            fontSize: isMobile ? "15px" : "16px",
            fontWeight: "bold",
            cursor: "pointer",
            marginTop: "24px",
            transition: "background-color 0.3s",
        },
        button2: {
            fontFamily: "Helvetica",
            backgroundColor: "#FFF2D3",
            color: "#FFB60C",
            border: "1px solid #FFB60C",
            padding: "10px 20px",
            borderRadius: "3px",
            fontSize: isMobile ? "15px" : "16px",
            fontWeight: "bold",
            cursor: "pointer",
            marginTop: "24px",
            marginLeft: isMobile ? "0" : "20px",
            transition: "background-color 0.3s",
        },
        button3: {
            fontFamily: "Helvetica",
            backgroundColor: "#FFF2D3",
            color: "#000000ff",
            border: "1px solid #000000ff",
            padding: "10px 20px",
            borderRadius: "3px",
            fontSize: isMobile ? "15px" : "16px",
            fontWeight: "bold",
            cursor: "pointer",
            marginTop: "24px",
            marginLeft: isMobile ? "0" : "20px",
            transition: "background-color 0.3s",
        },
        paragraphStyle: {
            fontSize: isMobile ? '13px' : '21px',
            lineHeight: 1.6,
            color: 'var(--color-text-secondary)',
            width: isMobile ? '100%' : '60%',
        },
    };

    return (
        <section style={styles.section}>
            <h2 style={styles.heading}>{t('PetFoundLostTitle')}</h2>
            <div style={{
                maxWidth: "1515px",
                margin: "0 auto",
            }}>
                <p style={styles.paragraphStyle}>
                    {t('PetFoundLostDescription1')}
                </p>
            </div>

            <div style={{
                maxWidth: "1515px",
                margin: "0 auto",
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
            }}>
                <button
                    style={styles.button}
                    onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = "#e6ad06";
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = "#FFB60C";
                    }}
                    onClick={() => {
                        navigate("/pet_lost_search");
                    }}
                >
                    {t('PetLostButton')}
                </button>

                <button
                    style={styles.button2}
                    onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = "#f5dea9ff";
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = "#FFF2D3";
                    }}
                    onClick={() => {
                        navigate("/pet_found_search");
                    }}
                >
                    {t('PetFoundButton')}
                </button>
                <button
                    style={styles.button3}
                    onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = "#acacacff";
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = "#FFF2D3";
                    }}
                    onClick={() => {
                        navigate("/all_lost_pets");
                    }}
                >
                    {t('ViewallLostPets')}
                </button>
            </div>

        </section>
    );
};

export default PetFoundLost;
